// This icon file is generated automatically.
var PExclamationOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 12 12", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M5 10.56a1 1 0 102 0 1 1 0 00-2 0zm.5-2.62h1c.07 0 .13-.06.13-.13V.56A.13.13 0 006.5.44h-1a.13.13 0 00-.13.12v7.25c0 .07.06.13.13.13z", "fill-rule": "nonzero" } }] }, "name": "p-exclamation", "theme": "outlined" };
export default PExclamationOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PExclamationOutlined.js
// module id = 3369
// module chunks = 0